import React from 'react';
import './Rating.style.css';
import star_red from 'assets/star_red.svg';
import star_gray from 'assets/star_gray.svg';

const Rating = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const {
    num = 5,
    rating = 0,
    layoutStyle = {},
    ratingStyle = {},
    onClick = () => {},
    readOnly = false,
  } = props;

  /* ===== State ===== */
  const [isHover, setIsHover] = React.useState(false);
  const [hoverIndex, setHoverIndex] = React.useState(rating - 1);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  const handleRatingHover = (e, r) => {
    if (e === 'enter') {
      setIsHover(true);
    } else {
      setIsHover(false);
    }
    setHoverIndex(r);
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div className="rating-layout" style={{ ...layoutStyle }}>
      {[...Array(num)].map((_, index) => (
        <img
          key={`rating-${index}`}
          src={
            isHover
              ? index <= hoverIndex
                ? star_red
                : star_gray
              : index < rating
              ? star_red
              : star_gray
          }
          alt={
            isHover
              ? index <= hoverIndex
                ? 'star_red icon'
                : 'star_gray icon'
              : index < rating
              ? 'star_red icon'
              : 'star_gray icon'
          }
          onClick={() => (readOnly ? null : onClick(index + 1))}
          onMouseEnter={() =>
            readOnly ? null : handleRatingHover('enter', index)
          }
          onMouseLeave={() =>
            readOnly ? null : handleRatingHover('leave', rating)
          }
          style={{ ...ratingStyle, cursor: readOnly ? 'default' : 'pointer' }} // 마우스 커서 변경
        />
      ))}
    </div>
  );
};

export default Rating;
